import React from 'react';
import Icon from '../atoms/Icon';

function JerseyIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 32 30">
      <g
        fill='currentColor'
        fillRule='evenodd'
      >
        <path d="M32 4.30769V12.5457H27.0769V29.7764H4.92308V12.5457H0V4.30769L11.488 0L12.0409 0.703125C12.0415 0.703868 12.044 0.70778 12.0481 0.71274C12.0563 0.722721 12.0721 0.740857 12.0938 0.765625C12.1374 0.815676 12.2075 0.892702 12.3017 0.987981C12.4917 1.18024 12.7745 1.44017 13.1358 1.69952C13.8674 2.22465 14.85 2.69952 16 2.69952C17.15 2.69952 18.1327 2.22465 18.8642 1.69952C19.2255 1.44017 19.5083 1.18024 19.6983 0.987981C19.7925 0.892702 19.8626 0.815676 19.9063 0.765625C19.9279 0.740857 19.9437 0.722721 19.9519 0.71274C19.956 0.70778 19.9585 0.703868 19.9591 0.703125L20.512 0L32 4.30769ZM21.2548 2.90745C21.0062 3.14367 20.6869 3.42213 20.3005 3.69952C19.3176 4.40513 17.8383 5.16106 16 5.16106C14.1617 5.16106 12.6824 4.40513 11.6995 3.69952C11.3128 3.42189 10.9927 3.1438 10.744 2.90745L2.46154 6.01442V10.0841H7.38462V27.3149H24.6154V10.0841H29.5385V6.01442L21.2548 2.90745Z"/>
        <path d="M28.3077 3.93029V8.85337H25.8462V3.93029H28.3077Z"/>
        <path d="M6.15385 3.93029V8.85337H3.69231V3.93029H6.15385Z"/>
        <path d="M14.7692 10.0841H12.3077V19.9303H14.7692V10.0841Z"/>
        <path d="M19.6923 10.0841H17.2308V19.9303H19.6923V10.0841Z"/>
        <path d="M20.9231 13.7764V11.3149H11.0769V13.7764H20.9231Z"/>
        <path d="M20.9231 18.6995V16.238H11.0769V18.6995H20.9231Z"/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(JerseyIcon);
